export const COLLAB_SYNC = 0;
export const COLLAB_STATE_VECTOR = 1;
export const COLLAB_UPDATE = 2;
export const COLLAB_AWARENESS = 3;
export const COLLAB_CONTROL = 4;

const encoder = new TextEncoder();
const decoder = new TextDecoder();

export function binaryCollaborationFrame(type, payload = new Uint8Array()) {
  const bytes = payload instanceof Uint8Array ? payload : new Uint8Array(payload);
  const frame = new Uint8Array(bytes.byteLength + 1);
  frame[0] = type;
  frame.set(bytes, 1);
  return frame;
}

export function jsonCollaborationFrame(value) {
  return binaryCollaborationFrame(COLLAB_CONTROL, encoder.encode(JSON.stringify(value)));
}

export function decodeCollaborationFrame(value) {
  const bytes = value instanceof Uint8Array ? value : new Uint8Array(value);
  if (bytes.byteLength < 1) throw new Error("Empty collaboration frame");
  return { type: bytes[0], payload: bytes.slice(1) };
}

export function decodeCollaborationJson(payload) {
  return JSON.parse(decoder.decode(payload));
}
